/**
 * Formata bytes para formato legível (KB, MB)
 */
export function formatBytes(bytes: number, decimals = 1): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * Valida tipo de arquivo
 */
export function validateFileType(filename: string): boolean {
  const ACCEPTED = ['pdf', 'docx', 'txt', 'md', 'png', 'jpg', 'jpeg', 'webp'];
  const ext = filename.split('.').pop()?.toLowerCase();
  return ext ? ACCEPTED.includes(ext) : false;
}

/**
 * Valida tamanho de arquivo
 */
export function validateFileSize(size: number, maxMB = 25): boolean {
  const maxBytes = maxMB * 1024 * 1024;
  return size <= maxBytes;
}

/**
 * Obtém ícone para tipo de arquivo
 */
export function getFileIcon(type?: string): string {
  if (!type) return '📎';
  
  if (type.includes('pdf')) return '📄';
  if (type.includes('word') || type.includes('docx')) return '📝';
  if (type.includes('text')) return '📃';
  if (type.includes('image')) return '🖼️';
  return '📎';
}
